import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
var _excluded = ["color", "size", "selected", "children", "allowMultiline", "label", "textEllipsis", "onDelete"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { _Chip } from "./styles";
import { Typography } from "../Typography";
import Close from '@material-ui/icons/Close';
export function Chip(_ref) {
  var color = _ref.color,
    size = _ref.size,
    selected = _ref.selected,
    children = _ref.children,
    allowMultiline = _ref.allowMultiline,
    label = _ref.label,
    textEllipsis = _ref.textEllipsis,
    onDelete = _ref.onDelete,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var chipLabel = /*#__PURE__*/React.createElement(Typography, {
    minHeight: true,
    style: {
      whiteSpace: allowMultiline ? 'normal' : textEllipsis ? 'nowrap' : undefined,
      width: textEllipsis ? '100%' : 'auto',
      overflow: textEllipsis ? 'hidden' : 'initial',
      textOverflow: textEllipsis ? 'ellipsis' : 'initial'
    }
  }, children ? children : label);
  return /*#__PURE__*/React.createElement(_Chip, _extends({
    size: size,
    selected: selected,
    color: color,
    label: chipLabel,
    onDelete: onDelete,
    deleteIcon: onDelete ? /*#__PURE__*/React.createElement(Close, null) : undefined
  }, otherProps));
}
Chip.defaultProps = {
  color: 'neutral',
  size: 'regular',
  selected: false
};